import React  from 'react';
import { Validators } from 'Utils/Constants';
import MaskedField from './MaskedField';

/**
 *
 * @param {PhoneField.defaultProps} props
 * @returns
 */
const PhoneField = (props) => {
  return (
    <MaskedField {...props} />
  );
}

PhoneField.defaultProps = {
  ...MaskedField.defaultProps,
  validators: [Validators.PHONE_FORMAT, Validators.PHONE_NOT_ALL_SAME],
  placeholder: '###-###-####',
  mask: '999-999-9999',
  maskChar: '',
  stripRegex: /-/g
};

export default PhoneField;